export const mergeTrips = (trips) => {
  if (!trips) {
    return [];
  }

  return trips.sort((a, b) => a.ordinalNumber - b.ordinalNumber)
    .flatMap(({ positions }) => positions)
    .sort((a, b) => a.positionTimestamp - b.positionTimestamp);
};
